
export default {
  name: 'ProducerSearch',
  props: {
    searchTerm: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      search: null,
      selectbox: null,
      path: 'contacts',
      activeOrder: {}
    }
  },
  computed: {
    members () {
      const contacts = this.$store.getters[`${this.path}/standardized`] || []
      const producers = contacts.filter((contact) => {
        if (Array.isArray(contact?.producesDp)) {
          return contact.producesDp.length > 0
        }
        if (Array.isArray(contact?.producesFu)) {
          return contact.producesFu.length > 0
        }
        return false
      })

      return producers.length ? producers : contacts
    }
  },
  watch: {
    searchTerm (newValue, oldValue) {
      if (newValue) {
        this.search = newValue
      }
    },
    selectbox (newValue) {
      if (newValue) {
        this.select(newValue)
      }
    }
  },
  async mounted () {
    const current = this.$store.getters[`${this.path}/standardized`] || []
    if (!current.length) {
      this.loading = true
      try {
        await this.$store.dispatch(`${this.path}/list`)
      } finally {
        this.loading = false
      }
    }
  },
  methods: {
    filterByFullName (item, queryText, itemText) {
      const search = (queryText || '').toString().toLowerCase()
      const text = (itemText || '').toString().toLowerCase()
      return text.includes(search)
    },
    select (item) {
      this.$router.push(`/pg/contacts/${item.id}`)
    },
    openOrderForm (data) {
      this.$emit('openOrderForm', data)
      this.search = null
      this.selectbox = null
    },
    openUsageForm (data) {
      this.$emit('openUsageForm', data)
      this.search = null
      this.selectbox = null
    }
  }
}
